import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#ff9000',
      dark: '#c56100',
      light: '#ffc146',
    },
    background: {
      default: '#312e38',
      paper: '#5a5762',
    },
    text: {
      primary: '#fff',
      secondary: '#929292',
    },
  },
  typography: {
    fontFamily: [
      'Roboto Slab',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  overrides: {
    MuiTextField: {
      root: {
        color: '#929292',
        // borderColor,
      },
    },
    MuiInputLabel: {
      root: {
        color: '#929292',
      },
    },
    MuiOutlinedInput: {
      root: {
        '&:hover': {
          borderColor: '#929292',
        },
      },
      notchedOutline: {
        borderColor: '#929292',
        '&:hover': {
          borderColor: '#929292',
        },
      },
    },
  },
});

export default theme;
